require('./reimburseInvestmentStep2ContentWithCosts.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
// @ components
const { OKMessage } = require("commonsComponents/OKMessage");
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ReimburseInvestmentDetailsWithCosts = require('components/hireInvestmentFunds/reimburseInvestmentDetailsWithCosts/reimburseInvestmentDetailsWithCosts');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
// @ constants
const { BROKER_REIMBURSE_FUND_ID } = require('constants/operationTypes');

class ReimburseInvestmentStep2WithCosts extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            immReimburseInvestment,
            immFund,
            operationParams
        } = this.props;
        const context = "brokerReimburseInvestmentStep2WithCosts";
        const descriptionKey = __CONTACT_CENTER__ ? `${context}-descriptionCC` : `${context}-description`;
        const hasContribution = immReimburseInvestment.getIn(['steps', '0', 'reimburseFund', 'hasActiveContribution']);
        const isTotalReimbursement = immReimburseInvestment.getIn(['steps', '0', 'type']) === 'total';
        return (
            <div className="reimburse-investment-step2-with-costs">
                <FormattedText
                    value={`${context}-title`}
                    className="reimburse-investment-step2-with-costs__title"
                />
                <ContactCenterRender>
                    <BlockInfo extraClass="reimburse-investment-step2-with-costs__block-info">
                        <FormattedText
                            value={descriptionKey}
                            className="reimburse-investment-step2-with-costs__text reimburse-investment-step2-with-costs__description"
                        />
                        <div className="reimburse-investment-step2-with-costs__details-container">
                            <ReimburseInvestmentDetailsWithCosts
                                immReimburseInvestment={immReimburseInvestment}
                                immFund={immFund}
                            />
                        </div>
                        <FormattedText
                            className="reimburse-investment-step2-with-costs__text reimburse-investment-step2-with-costs__cc-message"
                            value={`${context}-documentationMessage`}
                        />
                    </BlockInfo>
                </ContactCenterRender>
                <WebappRender>
                    <FormattedText
                        value={`${context}-description`}
                        className="reimburse-investment-step2-with-costs__description"
                    />
                    <ReimburseInvestmentDetailsWithCosts
                        immReimburseInvestment={immReimburseInvestment}
                        immFund={immFund}
                    />
                </WebappRender>
                <div className="reimburse-investment-step2-with-costs__conformity-message">
                    <OKMessage
                        type="informative"
                    >
                        <FormattedText value={`${context}-conformityMessage`} />
                        {
                        hasContribution && isTotalReimbursement &&
                        <FormattedText value={`${context}-cancelContributionMsg`} />
                        }
                    </OKMessage>
                </div>
                <div className="reimburse-investment-step2-with-costs__signature-container">
                    <SignaturePattern
                        operationType={BROKER_REIMBURSE_FUND_ID}
                        operationParams={operationParams}
                    />
                </div>
            </div>
        );
    }
}

ReimburseInvestmentStep2WithCosts.propTypes = {
    immReimburseInvestment: PropTypes.object.isRequired,
    immFund: PropTypes.object.isRequired,
    operationParams: PropTypes.object.isRequired,
};
module.exports = ReimburseInvestmentStep2WithCosts;
